import Appointment from './Appointment'

export { Appointment }

export default Appointment
